import * as firebase from "firebase/app"

const config = {
    apiKey: "AIzaSyDS3ZX3bjBzEY7i_p-lqJrldeHmeQubeGo",
    authDomain: "homepage-1de57.firebaseapp.com",
    projectId: "homepage-1de57",
    storageBucket: "homepage-1de57.appspot.com",
    messagingSenderId: "950606762736",
    appId: "1:950606762736:web:2954705568d6a8ed5be835"
}

let instance: firebase.FirebaseApp | null = firebase.getApps().length > 0 ? firebase.getApps()[0] : null

export function getFirebase() {
    if (typeof window === 'object') {
        if (instance) return instance
        instance = firebase.initializeApp(config)
        return instance
    }
    return null
}
